import React from 'react'
import Hero from "../Components/Hero"
import About from "../Components/About"

function Home() {
  return (
    <div>
        <Hero/>
        <About/>
    </div>
  )
}

export default Home